// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"77573607","605":"ab2c4b05","725":"f2ccbc8b"}[chunkId] + ".chunk.js";
};